.btn-scroll-to-top {
  display: none;
  position: fixed;
  bottom: 0;
  right: 20px;
  height: 35px;
  width: 50px;
  border: none;
  border-radius: 6px;
  background-color: $scrollToTopBG;
  padding-bottom: 19px;
  transform: translateY(10px);  
  @include transitionDefault(all);
  z-index: 1031;

  svg {
    @include svg-format(15px, 15px, $scrollToTopIcon);
    @include transitionDefault(fill);
  }

  &:hover, &:focus {
    transform: translateY(4px);      
    @include transitionDefault(all);
    background-color: $scrollToTopBGHover;

    svg {      
      @include transitionDefault(fill);
      fill: $scrollToTopIconHover;
    }    
  }
}